import { render } from "./SubscribeToTextAlerts.vue?vue&type=template&id=37b716fd"
import script from "./SubscribeToTextAlerts.vue?vue&type=script&lang=js"
export * from "./SubscribeToTextAlerts.vue?vue&type=script&lang=js"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__